export const SET_IS_GEO_ENABLED = 'SET_IS_GEO_ENABLED'
export const SET_CURRENT_LAT_LNG = 'SET_CURRENT_LAT_LNG'
export const SET_GEO_ERROR_STATUS = 'SET_GEO_ERROR_STATUS'
